import React, { useContext, useState } from "react";
import { AuthContext } from "../utils/AuthContext";

export default function PostFilters({
    searchQuery,
    setSearchQuery,
    onSearchSubmit,
    sortMode,
    setSortMode,
    postTypeSelect,
    setPostTypeSelect,
    postTypesList,
    handleResetFilters
}) {
    const { auth } = useContext(AuthContext);
    const [showFilters, setShowFilters] = useState(false);

    return (
        <div className="col-xl-3 col-lg-12 col-md-10 col-sm-12 public-square-left-column">

            {/* ── Tablet bar (lg only) ── */}
            <div className="d-none d-lg-flex d-xl-none ps-tablet-bar">
                <input
                    className="form-control ps-tablet-search"
                    type="text"
                    placeholder="Search Posts"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    onKeyDown={(e) => e.key === 'Enter' && onSearchSubmit()}
                />

                <button
                    className="btn create-post-button ps-tablet-create-btn"
                    data-bs-toggle="modal"
                    data-bs-target={auth.user?.user_id ? "#createPostModal" : "#loginModal"}
                >Create Post</button>

                <button
                    className="ps-filters-toggle-btn"
                    onClick={() => setShowFilters(v => !v)}
                    aria-expanded={showFilters}
                >
                    Filters <i className={`bi bi-chevron-${showFilters ? 'up' : 'down'}`} />
                </button>
            </div>

            {/* ── Tablet filter row (collapsible) ── */}
            {showFilters && (
                <div className="d-none d-lg-flex d-xl-none ps-tablet-filter-row">
                    <button className={`ps-filter-pill ${sortMode === 'recent' ? 'selected-posts-filter' : 'posts-filter-button'}`} onClick={() => setSortMode('recent')}><i className="bi bi-clock" /> Recent</button>
                    <button className={`ps-filter-pill ${sortMode === 'popular' ? 'selected-posts-filter' : 'posts-filter-button'}`} onClick={() => setSortMode('popular')}><i className="bi bi-fire" /> Popular</button>
                    <button className={`ps-filter-pill ${sortMode === 'random' ? 'selected-posts-filter' : 'posts-filter-button'}`} onClick={() => setSortMode('random')}><i className="bi bi-shuffle" /> Random</button>

                    <select
                        className="form-select ps-tablet-type-select"
                        value={postTypeSelect !== undefined ? postTypeSelect : ""}
                        onChange={(e) => setPostTypeSelect(e.target.value)}
                    >
                        <option value="" disabled>Filter by Type</option>
                        {postTypesList.map(postType => (
                            <option key={postType.posttype_id} value={postType.posttype_id}>{postType.post_type}</option>
                        ))}
                    </select>

                    <button className="ps-tablet-reset-btn" onClick={handleResetFilters}>Reset</button>
                </div>
            )}

            {/* ── Desktop / mobile: buttons ── */}
            <div className="public-square-buttons d-block d-lg-none d-xl-block">
                <button
                    className="btn create-post-button mb-2"
                    data-bs-toggle="modal"
                    data-bs-target={auth.user?.user_id ? "#createPostModal" : "#loginModal"}
                >Create Post</button>

                {/* ── Desktop / mobile: search ── */}
                <div className="input-group  mt-3 mb-3">
                    <input
                        className="form-control"
                        type="text"
                        placeholder="Search Posts"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        onKeyDown={(e) => e.key === 'Enter' && onSearchSubmit()}
                    />
                    <button
                        className="btn posts-search-submit-btn"
                        type="button"
                        onClick={onSearchSubmit}
                        aria-label="Search"
                    >
                        <i className="bi bi-search" />
                    </button>
                </div>

                <div className="row posts-filter-div">
                    <button className={`ms-0 ${sortMode === 'recent' ? "selected-posts-filter" : "posts-filter-button"}`} onClick={() => setSortMode('recent')}><i className="bi bi-clock"> </i>Recent</button>
                    <button className={`${sortMode === 'popular' ? "selected-posts-filter" : "posts-filter-button"}`} onClick={() => setSortMode('popular')}><i className="bi bi-fire"> </i>Popular</button>
                    <button className={`me-0 ${sortMode === 'random' ? "selected-posts-filter" : "posts-filter-button"}`} onClick={() => setSortMode('random')}><i className="bi bi-shuffle"> </i>Random</button>
                </div>

                <div className="row posts-filter-div">
                    <select className="form-select post-type-filter-select" value={postTypeSelect !== undefined ? postTypeSelect : ""} onChange={(e) => setPostTypeSelect(e.target.value)}>
                        <option value="" disabled>Filter by Type</option>
                        {postTypesList.map(postType => (
                            <option key={postType.posttype_id} value={postType.posttype_id}>{postType.post_type}</option>
                        ))}
                    </select>
                    <button className="clear-posts-filter-button" onClick={handleResetFilters}>Reset</button>
                </div>
            </div>

            

        </div>
    );
}
